'use client';

import AddAlertIcon from '@mui/icons-material/AddAlert';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from '@mui/material';
import { useElementViewedContext } from '@repo/segment/Analytics/ElementViewed';

type PromotionalBannerLinkProps = {
  variant: 'rate-monitor' | 'account-monitor';
  href: string;
};

export function PromotionalBannerLink({ variant, href }: PromotionalBannerLinkProps) {
  const isRateMonitor = variant === 'rate-monitor';
  const ctaCopy = isRateMonitor ? 'GET RATE ALERTS' : 'START RATE MONITORING';
  const { fireElementInteracted } = useElementViewedContext();

  const handleClick = () => {
    fireElementInteracted('click', { itemCopy: ctaCopy });
  };

  return (
    <Link
      component="a"
      sx={{
        backgroundColor: 'white',
        borderRadius: '100px',
        color: 'black',
        paddingTop: '14px',
        paddingBottom: '14px',
        paddingLeft: '16px',
        paddingRight: '16px',
        marginLeft: {
          md: 'auto',
        },
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '16px',
        gap: '10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        letterSpacing: '0.113px',
        textDecoration: 'none',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        '&:hover': {
          textDecoration: 'none',
          outline: '2px solid #97CB65',
          boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.15)',
        },
      }}
      href={href}
      rel="nofollow"
      onClick={handleClick}
    >
      {isRateMonitor ? <AddAlertIcon sx={{ fontSize: '22px' }} /> : null}
      {ctaCopy}
      {isRateMonitor ? null : <ArrowForwardIcon sx={{ fontSize: '22px' }} />}
    </Link>
  );
}
